exports.MobileImageUploader = {
  path: '/mobileimageuploader/:id',
  name: 'MobileImageUploader'
}